import React from 'react';
import '../assets/css/capabilities.css';

const Capabilities = () => {
    const capabilityData = [
        // { title: "1. Advanced Reactor Systems", desc: "Precision-controlled reactor", icon: "⚙️" },
        { title: "In-House Quality Lab", desc: "Strict quality testing", icon: "🔬" },
        { title: "Custom Resin Formulations", desc: "Tailored resin solutions", icon: "🧬" },
        { title: "Reliable Packaging & Dispatch", desc: "Where safety meets timeliness", icon: "📦" },
        { title: "Technical Support", desc: "We have a dedicated team of professionals who can effectively handle the challenges and requirements of end users of synthetic resins", icon: "🎧" },
        // { title: "Sustainable Processes", desc: "Eco-focused production", icon: "🍃" }
    ];

    return (
        <section className="cap-container">
            <div className="cap-header">
                <span className="cap-subtitle">WHY KRISHNA CHEMICAL & POLYMER</span>
                <h2 className="cap-title">Capabilities That Power Our Reliable Resin Manufacturer</h2>
                <p className='cap-intro'>
                    At Krishna Chemicals & Polymer, our strength lies in the systems, processes, and support we have built over the
                    years. Every batch we produce is backed by advanced technology, skilled expertise, and an unwavering commitment
                    to quality.
                </p>
            </div>

            <div className="cap-grid">
                {capabilityData.map((item, index) => (
                    <div className="cap-card" key={index}>
                        <div className="cap-icon-box">
                            <span className="cap-icon">{item.icon}</span>
                        </div>
                        <div className="cap-text-content">
                            <h3 className="cap-card-title">{item.title}</h3>
                            <p className="cap-card-desc">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Capabilities;